import useAppointmentStore from '@/store/AppointmentStore';

const useResetTimeslotOnModify = () => {
  const { setSelectedStartTime, setSelectedEndTime, setSelectedAgent } =
    useAppointmentStore();

  const resetTimeslot = () => {
    setSelectedStartTime('');
    setSelectedEndTime('');
    setSelectedAgent({});
  };

  return { resetTimeslot };
};

export default useResetTimeslotOnModify;
